import React from "react";
import Services from "../reusables/Services";

const ServicesBody = () => {
  return (
    <section className="section section-spacing-100 dark-bg">
      <div className="large">
        <div className="section-content">
          <Services />
        </div>
      </div>
    </section>
  );
};

export default ServicesBody;
